import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShareLink } from '../Actions/Wishlist.action';
import { translate } from '../Services/translation';

const SharedWishlistLink = ({ onClose }) => {
    const ref = useRef(null);
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const shareLink = useSelector((state) => state.wishlist.sharelink);
    const activeWishlist = useSelector((state) => state.wishlist.active);
    const wishlists = useSelector((state) => state.wishlist.lists);
    const wishlistId = wishlists.find(
        (wishlist) => wishlist.name === activeWishlist
    ).id;

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.select();
        }
        dispatch(getShareLink(wishlistId));
    }, []);

    const handleCopy = () => {
        const copybutton = document.getElementById('sharelink-copy-button');

        if (inputRef.current) {
            navigator.clipboard.writeText(inputRef.current.value);
            copybutton.classList.add('copied');
            setTimeout(() => {
                copybutton.classList.remove('copied');
            }, 2000);
        }
    };

    return (
        <>
            <div className="wishlist-share__container">
                <div className="wishlist-share__info" ref={ref}>
                    <div className="wishlist-share__close-button-wrapper">
                        <p className="wishlist-share__title">
                            {translate('wishlist.sharelink')}
                        </p>
                        <span
                            className="wishlist-add__close-button"
                            onClick={onClose}
                        ></span>
                    </div>
                    <div className="wishlist-share__link-content">
                        <input
                            type="text"
                            value={shareLink}
                            className="wishlist-share__link-text"
                            readOnly
                            ref={inputRef}
                        />
                        <button
                            id="sharelink-copy-button"
                            onClick={handleCopy}
                            className="wishlist-share__copy-button"
                        ></button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SharedWishlistLink;
